import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Language } from '../models/language';

@Injectable({
	providedIn: 'root',
})
export class LanguageService {
	public spokenLanguage$: BehaviorSubject<string> = new BehaviorSubject<string>('en');
	public supportedLanguages$: BehaviorSubject<Language[]> = new BehaviorSubject<Language[]>([
		{ code: 'en', label: 'English' },
		{ code: 'es', label: 'Spanish' },
	]);

	constructor() {}

	public selectSpokenLanguage(language: string) {
		this.spokenLanguage$.next(language);
	}

	/**
	 * Converts say en to English using the supportedLanguages$ BehaviorSubject.
	 *
	 * Returns original code if no long form version is found.
	 *
	 * @public
	 * @param {string} code
	 * @returns {name}
	 */
	public convertCodeToName(code: string): string {
		const language = this.supportedLanguages$.getValue().find(lang => lang.code === code);
		return language ? language.label : code;
	}
}
